import { z } from 'zod';

import { breakFQDN } from '../../../shared/utils/break-fqdn';

const envSchema = z.object({
  VITE_SERVER_FQDN: z.string().min(1),

  VITE_NMI_PUBLIC_KEY: z.string().min(1).optional(),
});

const auxEnv = envSchema.parse(import.meta.env);

export const env = {
  ...auxEnv,
  VITE_SERVER_FQDN: undefined,
  ...breakFQDN(auxEnv.VITE_SERVER_FQDN),
};
